import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import { VM_GLOBAL_CONFIG, VmGlobalConfig } from './../config.model';

@Pipe({
  name: 'asset',
})
export class AssetPipe implements PipeTransform {
  constructor(@Inject(VM_GLOBAL_CONFIG) @Optional() private config: VmGlobalConfig) {}

  transform(value: string): string {
    return (this.config?.assetsPath || '') + value;
  }
}
